import { usePageMeta } from "@/lib/pageMeta";
import { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api, { apiErr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Skeleton } from "@/components/ui/skeleton";
import { Percent, Save } from "lucide-react";
import { toast } from "sonner";

export default function Parameters() {
    const qc = useQueryClient();
    const { data, isLoading } = useQuery({ queryKey: ["parameters"], queryFn: async () => (await api.get("/parameters")).data });
    const [inflation, setInflation] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => { if (data) setInflation(String(data.inflation_rate)); }, [data]);

    const save = async () => {
        setSaving(true);
        try {
            await api.put("/parameters", { inflation_rate: parseFloat(inflation) });
            qc.invalidateQueries();
            toast.success("Parameters saved");
        } catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
    };

    usePageMeta("Global assumptions used across analytics", "Parameters");
    return (
        <div className="space-y-6 max-w-2xl">
            <Card className="p-5">
                {isLoading ? <Skeleton className="h-24 rounded-lg" /> : (
                    <div className="space-y-5">
                        <div className="flex items-start gap-3">
                            <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0 mt-1"><Percent className="w-4 h-4 text-primary" /></div>
                            <div className="flex-1">
                                <Label className="font-medium">Inflation Rate (%)</Label>
                                <p className="text-xs text-muted-foreground mb-2">Used in the Sharpe ratio calculation on the Holdings page.</p>
                                <Input type="number" step="0.1" value={inflation} onChange={(e) => setInflation(e.target.value)}
                                    className="num w-40" data-testid="inflation-input" />
                            </div>
                        </div>
                        <Button onClick={save} disabled={saving} data-testid="save-parameters-btn"><Save className="w-4 h-4 mr-1.5" />Save parameters</Button>
                    </div>
                )}
            </Card>
        </div>
    );
}
